import type { EventCoupon } from "@/features/events/api/event-coupon";

export type CouponViewerState = "logged-out" | "unconfirmed" | "confirmed";

export type CouponRevealState =
  | { status: "loading" }
  | { status: "error" }
  | { status: "ready"; code: string | null };

export function getCouponViewerState(
  isLoggedIn: boolean,
  isUserConfirmed: boolean
): CouponViewerState {
  if (!isLoggedIn) return "logged-out";
  if (isUserConfirmed) return "confirmed";
  return "unconfirmed";
}

export function getCouponRevealState(
  isCouponLoading: boolean,
  isCouponError: boolean,
  coupon: EventCoupon | undefined
): CouponRevealState | undefined {
  if (isCouponLoading) return { status: "loading" };
  if (isCouponError) return { status: "error" };
  if (coupon) return { status: "ready", code: coupon.code };
  return undefined;
}

export function getLockedCaption(
  viewerState: CouponViewerState,
  hasCouponCode: boolean
): string {
  if (viewerState === "logged-out") return "Entre para ver o cupom";
  if (hasCouponCode) return "Confirme presença para ver o código";
  return "Confirme presença para garantir";
}
